'use strict';

exports.__esModule = true;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _startCase2 = require('lodash/startCase');

var _startCase3 = _interopRequireDefault(_startCase2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _doctifyUtils = require('doctify-utils');

var _medicalSpecialty = require('../transformers/medical-specialty');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DECIMAL_PLACES = 2;

var SchemaPhysician = function (_React$Component) {
    (0, _inherits3.default)(SchemaPhysician, _React$Component);

    function SchemaPhysician(props) {
        (0, _classCallCheck3.default)(this, SchemaPhysician);
        return (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
    }

    SchemaPhysician.prototype.render = function render() {
        var jsonld = {
            member: [],
            memberOf: [],
            makesOffer: []
        };

        var specialistData = (0, _get3.default)(this.props, 'specialistData', {});
        var attributes = (0, _get3.default)(specialistData, 'attributes');
        var uriId = (0, _get3.default)(specialistData, 'uri_id');
        var name = (0, _get3.default)(specialistData, 'name');

        var about = ((0, _get3.default)(attributes, 'about') || '').replace(/<\/?[^>]+(>|$)/g, '').replace(/&rsquo;/g, '’').replace(/&nbsp;/g, ' ');

        jsonld = uriId && (0, _extends3.default)({}, jsonld, {
            name: name,
            'description': about,
            '@type': 'Physician',
            '@context': 'http://schema.org',
            '@id': 'https://www.doctify.co.uk/specialist/' + uriId,
            'url': 'https://www.doctify.co.uk/specialist/' + uriId
        }) || jsonld;

        var profileFeaturedImage = (0, _get3.default)(attributes, 'profile_featured_image');

        jsonld = profileFeaturedImage && (0, _extends3.default)({}, jsonld, {
            logo: profileFeaturedImage + '_lg.jpg',
            photo: {
                '@type': 'CreativeWork',
                'url': profileFeaturedImage + '_lg.jpg'
            },
            image: profileFeaturedImage + '_lg.jpg'
        }) || jsonld;

        var practices = (0, _get3.default)(specialistData, 'practices', []);

        practices.forEach(function (practice) {
            if (practice.status !== 'approved') {
                return;
            }
            jsonld.member.push({
                'name': practice.name,
                '@type': 'Organization',
                'url': 'https://www.doctify.co.uk/practice/' + practice.practiceUri,
                'sameAs': 'https://www.doctify.co.uk/practice/' + practice.practiceUri
            });
        });

        var insurers = (0, _get3.default)(specialistData, 'insurers', []);

        insurers.forEach(function (insurer) {
            jsonld.memberOf.push({
                'name': insurer.name,
                '@type': 'ProgramMembership',
                'url': insurer.website,
                'sameAs': insurer.website
            });
        });

        var consultationFees = (0, _get3.default)(attributes, 'consultation_fees', []);

        consultationFees.forEach(function (consultation) {
            if (!consultation.price) {
                return;
            }
            jsonld.makesOffer.push({
                '@type': 'Offer',
                'price': consultation.price,
                'priceCurrency': consultation.currency || 'GBP',
                'url': 'https://www.doctify.co.uk/specialist/' + uriId,
                'name': (0, _startCase3.default)((consultation.consultation || 'New') + ' Consultation'),
                'description': (0, _startCase3.default)((consultation.consultation || 'New') + ' Consultation Fee'),
                'itemOffered': {
                    '@type': 'Service',
                    'url': 'https://www.doctify.co.uk/specialist/' + uriId
                }
            });
        });

        var specialties = (0, _get3.default)(specialistData, 'specialties', []);

        specialties.forEach(function (specialty) {
            jsonld.makesOffer.push({
                'price': 'N/A',
                '@type': 'Offer',
                'name': specialty.name,
                'url': 'https://www.doctify.co.uk/specialist/' + uriId,
                'description': (0, _startCase3.default)(specialty.name + ' Specialist'),
                'itemOffered': {
                    '@type': 'Service',
                    'url': 'https://www.doctify.co.uk/specialist/' + uriId
                }
            });

            if (specialty.parent_name === 'abstract_top_level_keyword') {
                var schemaFriendlySpecialtyInfo = (0, _medicalSpecialty.mapSpecialtyToSchemaMedicalSpecialty)(specialty.name);
                var schemaType = schemaFriendlySpecialtyInfo.type;
                var schemaName = schemaFriendlySpecialtyInfo.name;
                jsonld[schemaType] = schemaName;
            }
        });

        var numberOfReviews = (0, _get3.default)(specialistData, 'number_of_reviews');
        var averageRating = (0, _get3.default)(specialistData, 'averageRating');

        if (numberOfReviews > 0 && averageRating > 0) {
            jsonld.aggregateRating = {
                '@type': 'AggregateRating',
                'reviewCount': numberOfReviews,
                'ratingValue': +parseFloat(averageRating).toFixed(DECIMAL_PLACES)
            };
        }

        return _react2.default.createElement('script', { defer: true, type: 'application/ld+json', dangerouslySetInnerHTML: { __html: (0, _stringify2.default)((0, _doctifyUtils.sanitize)(jsonld)) } });
    };

    return SchemaPhysician;
}(_react2.default.Component);

exports.default = SchemaPhysician;


SchemaPhysician.displayName = 'SchemaPhysician';
SchemaPhysician.propTypes = {};

SchemaPhysician.defaultProps = {
    renderMode: 'json',
    specialistData: { 'uri_id': null },
    reviewData: { 'aggregate_review': -1 }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/schema-generator/lib/components/schema-physician.js
// module id = 1119
// module chunks = 0